(() => {
  let isObserverSet = false; // Flag to track if observer is already set up

  window.addEventListener("abra:announced", () => {
    setTimeout(() => {
      const quickAddButtons = document.querySelectorAll(
        ".product-card__quick-add-btn"
      );

      console.log("abra", quickAddButtons);
      quickAddButtons.forEach((button) => {
        button.addEventListener("click", () => {
          // Skip if observer is already set
          if (isObserverSet) return;

          // Wait for drawer to be added to DOM
          const checkDrawer = setInterval(() => {
            const drawerCard = document.querySelector(
              ".product-card-drawer__drawer-content .product-card"
            );

            if (drawerCard) {
              clearInterval(checkDrawer);

              // Create mutation observer
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "data-variant-id"
                  ) {
                    window.dispatchEvent(new Event("abra:render"));
                  }
                });
              });

              // Start observing the card element for attribute changes
              observer.observe(drawerCard, {
                attributes: true,
                attributeFilter: ["data-variant-id"],
              });

              isObserverSet = true; // Mark observer as set
            }
          }, 100);
        });
      });
    }, 800);
  });
})();
